(function() {

Object.assign(dmx.rules, {

    required: {
        message: 'This field is required.',
        validity: function(element) {
            if (element.type.toLowerCase() == 'checkbox' || element.type.toLowerCase() == 'radio') {
                //return element.checked;
                if (element.name) {
                    return !!document.querySelector('[name="' + element.name + '"]:checked');
                } else {
                    return element.checked;
                }
            }

            if (element.hasAttribute('medium-editor-textarea-id')) {
                return !!(element.value && !/^\s*<p[^>]*>\s*<br[^>]*>\s*<\/p>\s*$/.test(element.value))
            }

            return !!(element.value && element.value.length);
        }
    },

    email: {
        message: 'Please enter a valid email address.',
        validity: function(element) {
            return /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFFu20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/i.test(element.value);
        }
    },

    url: {
        message: 'Please enter a valid URL.',
        validity: function(element) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(element.value);
        }
    },

    datetime: {
        message: 'Please enter a valid datetime.',
        validity: function(element) {
            return /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[T ]([01][0-9]|2[0-4]):[0-5][0-9](:([0-5][0-9]|60))?Z?$/.test(element.value);
        }
    },

    date: {
        message: 'Please enter a valid date.',
        validity: function(element) {
            return /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(element.value);
        }
    },

    time: {
        message: 'Please enter a valid time.',
        validity: function(element) {
            return /^([01][0-9]|2[0-4]):[0-5][0-9](:([0-5][0-9]|60))?$/.test(element.value);
        }
    },

    month: {
        message: 'Please enter a valid month.',
        validity: function(element) {
            return /^\d{4}-(0[1-9]|1[012])$/.test(element.value);
        }
    },

    week: {
        message: 'Please enter a valid week.',
        validity: function(element) {
            return /^\d{4}-W(0[1-9]|[1-4][0-9]|5[0-3])$/.test(element.value);
        }
    },

    color: {
        message: 'Please enter a color in the format #xxxxxx.',
        validity: function(element) {
            return /^#[a-fA-F0-9]{6}$/.test(element.value);
        }
    },

    number: {
        message: 'Please enter a valid number.',
        validity: function(element) {
            return /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(element.value);
        }
    },

    min: {
        message: 'Please enter a value greater than or equal to {0}.',
        validity: function(element, param) {
            if (element.type == 'number' || element.type == 'range') {
                return +element.value >= param;
            } else {
                return element.value >= param;
            }
        }
    },

    max: {
        message: 'Please enter a value less than or equal to {0}.',
        validity: function(element, param) {
            if (element.type == 'number' || element.type == 'range') {
                return +element.value <= param;
            } else {
                return element.value <= param;
            }
        }
    },

    pattern: {
        message: 'Invalid format.',
        validity: function(element, param) {
            if (!/^text|search|url|tel|email|password$/i.test(element.type)) {
                return true;
            }

            if (typeof param == 'string') {
                param = new RegExp('^(?:' + param + ')$');
            }

            return param.test(element.value);
        }
    },

    minlength: {
        message: 'Please enter at least {0} characters.',
        validity: function(element, param) {
            return element.value.length >= param;
        }
    },

    maxlength: {
        message: 'Please enter no more than {0} characters.',
        validity: function(element, param) {
            return element.value.length <= param;
        }
    },

    alphanumeric: {
        message: 'Letters, numbers, and underscores only please.',
        validity: function(element) {
            return /^\w+$/i.test(element.value);
        }
    },

    lettersonly: {
        message: 'Letters only please.',
        validity: function(element) {
            return /^[a-z]+$/i.test(element.value);
        }
    },

    letterswithbasicpunc: {
        message: 'Letters or punctuation only please.',
        validity: function(element) {
            return /^[a-z\-.,()'"\s]+$/i.test(element.value);
        }
    },

    nowhitespace: {
        message: 'No white space please.',
        validity: function(element) {
            return /^\S+$/i.test(element.value);
        }
    },

    digits: {
        message: 'Please enter only digits.',
        validity: function(element) {
            return /^\d+$/.test(element.value);
        }
    },

    creditcard: {
        message: 'Please enter a valid credit card number.',
        validity: function(element) {
            var value = element.value;

            // accept only spaces, digits and dashes
            if ( /[^0-9 \-]+/.test( value ) ) {
				return false;
			}

			var nCheck = 0,
				nDigit = 0,
				bEven = false,
				n, cDigit;

			value = value.replace( /\D/g, "" );

			// Basing min and max length on
			// http://developer.ean.com/general_info/Valid_Credit_Card_Types
			if ( value.length < 13 || value.length > 19 ) {
				return false;
			}

			for ( n = value.length - 1; n >= 0; n--) {
				cDigit = value.charAt( n );
				nDigit = parseInt( cDigit, 10 );
				if ( bEven ) {
					if ( ( nDigit *= 2 ) > 9 ) {
						nDigit -= 9;
					}
				}
				nCheck += nDigit;
				bEven = !bEven;
			}

			return ( nCheck % 10 ) === 0;
        }
    },

    bic: {
        message: 'Please specify a valid BIC code.',
        validity: function(element) {
            return /^([A-Z]{6}[A-Z2-9][A-NP-Z1-2])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(element.value);
        }
    },

    iban: {
        message: 'Please specify a valid IBAN.',
        validity: function(element) {
            // remove spaces and to upper case
        	var iban = element.value.replace(/ /g, "").toUpperCase(),
        		ibancheckdigits = "",
        		leadingZeroes = true,
        		cRest = "",
        		cOperator = "",
        		countrycode, ibancheck, charAt, cChar, bbanpattern, bbancountrypatterns, ibanregexp, i, p;

        	// check the country code and find the country specific format
        	countrycode = iban.substring(0, 2);
        	bbancountrypatterns = {
        		"AL": "\\d{8}[\\dA-Z]{16}",
        		"AD": "\\d{8}[\\dA-Z]{12}",
        		"AT": "\\d{16}",
        		"AZ": "[\\dA-Z]{4}\\d{20}",
        		"BE": "\\d{12}",
        		"BH": "[A-Z]{4}[\\dA-Z]{14}",
        		"BA": "\\d{16}",
        		"BR": "\\d{23}[A-Z][\\dA-Z]",
        		"BG": "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
        		"CR": "\\d{17}",
        		"HR": "\\d{17}",
        		"CY": "\\d{8}[\\dA-Z]{16}",
        		"CZ": "\\d{20}",
        		"DK": "\\d{14}",
        		"DO": "[A-Z]{4}\\d{20}",
        		"EE": "\\d{16}",
        		"FO": "\\d{14}",
        		"FI": "\\d{14}",
        		"FR": "\\d{10}[\\dA-Z]{11}\\d{2}",
        		"GE": "[\\dA-Z]{2}\\d{16}",
        		"DE": "\\d{18}",
        		"GI": "[A-Z]{4}[\\dA-Z]{15}",
        		"GR": "\\d{7}[\\dA-Z]{16}",
        		"GL": "\\d{14}",
        		"GT": "[\\dA-Z]{4}[\\dA-Z]{20}",
        		"HU": "\\d{24}",
        		"IS": "\\d{22}",
        		"IE": "[\\dA-Z]{4}\\d{14}",
        		"IL": "\\d{19}",
        		"IT": "[A-Z]\\d{10}[\\dA-Z]{12}",
        		"KZ": "\\d{3}[\\dA-Z]{13}",
        		"KW": "[A-Z]{4}[\\dA-Z]{22}",
        		"LV": "[A-Z]{4}[\\dA-Z]{13}",
        		"LB": "\\d{4}[\\dA-Z]{20}",
        		"LI": "\\d{5}[\\dA-Z]{12}",
        		"LT": "\\d{16}",
        		"LU": "\\d{3}[\\dA-Z]{13}",
        		"MK": "\\d{3}[\\dA-Z]{10}\\d{2}",
        		"MT": "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
        		"MR": "\\d{23}",
        		"MU": "[A-Z]{4}\\d{19}[A-Z]{3}",
        		"MC": "\\d{10}[\\dA-Z]{11}\\d{2}",
        		"MD": "[\\dA-Z]{2}\\d{18}",
        		"ME": "\\d{18}",
        		"NL": "[A-Z]{4}\\d{10}",
        		"NO": "\\d{11}",
        		"PK": "[\\dA-Z]{4}\\d{16}",
        		"PS": "[\\dA-Z]{4}\\d{21}",
        		"PL": "\\d{24}",
        		"PT": "\\d{21}",
        		"RO": "[A-Z]{4}[\\dA-Z]{16}",
        		"SM": "[A-Z]\\d{10}[\\dA-Z]{12}",
        		"SA": "\\d{2}[\\dA-Z]{18}",
        		"RS": "\\d{18}",
        		"SK": "\\d{20}",
        		"SI": "\\d{15}",
        		"ES": "\\d{20}",
        		"SE": "\\d{20}",
        		"CH": "\\d{5}[\\dA-Z]{12}",
        		"TN": "\\d{20}",
        		"TR": "\\d{5}[\\dA-Z]{17}",
        		"AE": "\\d{3}\\d{16}",
        		"GB": "[A-Z]{4}\\d{14}",
        		"VG": "[\\dA-Z]{4}\\d{16}"
        	};

        	bbanpattern = bbancountrypatterns[countrycode];
        	// As new countries will start using IBAN in the
        	// future, we only check if the countrycode is known.
        	// This prevents false negatives, while almost all
        	// false positives introduced by this, will be caught
        	// by the checksum validation below anyway.
        	// Strict checking should return FALSE for unknown
        	// countries.
        	if (typeof bbanpattern !== "undefined") {
        		ibanregexp = new RegExp("^[A-Z]{2}\\d{2}" + bbanpattern + "$", "");
        		if (!(ibanregexp.test(iban))) {
        			return false; // invalid country specific format
        		}
        	}

        	// now check the checksum, first convert to digits
        	ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
        	for (i = 0; i < ibancheck.length; i++) {
        		charAt = ibancheck.charAt(i);
        		if (charAt !== "0") {
        			leadingZeroes = false;
        		}
        		if (!leadingZeroes) {
        			ibancheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(charAt);
        		}
        	}

        	// calculate the result of: ibancheckdigits % 97
        	for (p = 0; p < ibancheckdigits.length; p++) {
        		cChar = ibancheckdigits.charAt(p);
        		cOperator = "" + cRest + "" + cChar;
        		cRest = cOperator % 97;
        	}
        	return cRest === 1;
        }
    },

    vat: {
        message: 'Please specify a valid VAT Number.',
        validity: function(element) {
            return /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/.test(element.value);
        }
    },

    integer: {
        message: 'A positive or negative non-decimal number please.',
        validity: function(element) {
            return /^-?\d+$/.test(element.value);
        }
    },

    ipv4: {
        message: 'Please enter a valid IP v4 address.',
        validity: function(element) {
            return /^(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)$/i.test(element.value);
        }
    },

    ipv6: {
        message: 'Please enter a valid IP v6 address.',
        validity: function(element) {
            return /^((([0-9A-Fa-f]{1,4}:){7}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){6}:[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){5}:([0-9A-Fa-f]{1,4}:)?[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){4}:([0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){3}:([0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){2}:([0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){6}((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|(([0-9A-Fa-f]{1,4}:){0,5}:((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|(::([0-9A-Fa-f]{1,4}:){0,5}((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|([0-9A-Fa-f]{1,4}::([0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})|(::([0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){1,7}:))$/i.test(element.value);
        }
    },

    minitems: {
        message: 'Please select at least {0} items.',
        validity: function(element, param) {
            return getCount(element) >= param;
        }
    },

    maxitems: {
        message: 'Please select no more tham {0} items.',
        validity: function(element, param) {
            return getCount(element) <= param;
        }
    },

    equalto: {
        message: 'Please enter the same value again.',
        validity: function(element, param) {
            if (param[0] != '#') param = '[name="' + param + '"]';
            var target = element.form.querySelector(param);
            if (!target) {
                console.warn('Target element ' + param + ' for equalTo rule not found.');
                return true;
            }
            return element.value == target.value;
        }
    },

    notequalto: {
        message: 'Please enter a different value, values must not be the same.',
        validity: function(element, param) {
            if (param[0] != '#') param = '[name="' + param + '"]';
            var target = element.form.querySelector(param);
            if (!target) {
                console.warn('Target element ' + param + ' for equalTo rule not found.');
                return true;
            }
            return element.value != target.value;
        }
    }

});

function getCount(element) {
    if (element.nodeName == 'SELECT') {
        return dmx.array(element.options).reduce(function(n, opt) {
            return n + opt.selected;
        }, 0);
    }

    if (element.type.toLowerCase() == 'checkbox') {
        return dmx.array(element.form.elements).reduce(function(n, elm) {
            return n + (elm.name == element.name && elm.checked);
        }, 0);
    }

    return 1;
}

})();
